module.exports = __webpack_public_path__ + "img/clientes.6b3d11da.jpeg";